import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { DropZone } from "@/ui/organisms/DropZone";
import clsx from "clsx";
import { useState } from "react";
import { Form, Select } from "@/ui/organisms/Form";
import * as yup from "yup";
import { selectOptionsFromMap } from "@/utils/misc/selectOptionsFromMap";
import { uploadFileMutation } from "@/entities/FileService/File.mutations";
import { useApiMutation } from "@/api/hooks";

enum FileContentType {
    BALANCE_SHEET = "balance_sheet",
    INCOME_STATEMENT = "income_statement",
    FINANCIAL_SUMMARY = "financial_summary",
    COMPANY_DECK = "company_deck",
    CAP_TABLE = "cap_table",
    TRANSACTION_DATA = "transaction_data",
    MIXED = "mixed",
    OTHER = "other",
    UNKNOWN = "unknown",
}

const FILE_CONTENT_TYPE_LABELS = {
    [FileContentType.BALANCE_SHEET]: "Balance sheet",
    [FileContentType.INCOME_STATEMENT]: "Income statement",
    [FileContentType.FINANCIAL_SUMMARY]: "Financial summary",
    [FileContentType.COMPANY_DECK]: "Company deck",
    [FileContentType.CAP_TABLE]: "Cap table",
    [FileContentType.TRANSACTION_DATA]: "Transaction data",
    [FileContentType.MIXED]: "Mixed",
    [FileContentType.OTHER]: "Other",
    [FileContentType.UNKNOWN]: "Unknown",
};

export function NewUploadPanel() {
    const [file, setFile] = useState<File | null>(null);
    const { mutate: uploadFile } = useApiMutation(uploadFileMutation);

    return (
        <div
            className={clsx(
                "px-6",
                "absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-6 flex flex-col">
                <RightSidebarButton />
                <h2 className="pageheading">Upload a new file</h2>
            </div>

            <p className="ui-element">Selected file</p>
            <DropZone
                file={file || undefined}
                onRemove={() => {
                    setFile(null);
                }}
                onFileUpload={(file) => {
                    console.log(file);
                    setFile(file);
                }}
            />
            <Form
                id="upload:form"
                schema={yup
                    .object({
                        contentType: yup.mixed<FileContentType>().required(),
                    })
                    .required()}
                onSubmit={(data) => {
                    console.log(data);
                    if (!file) {
                        return;
                    }
                    uploadFile({
                        name: file.name,
                        mimeType: file.type,
                        contentType: data.contentType,
                        file,
                    });
                }}
            >
                <div className="mt-6 grid grid-cols-1 gap-6">
                    <Select
                        name="contentType"
                        label="What type of content is in this file?"
                        placeholder="Select content type"
                        options={selectOptionsFromMap(FILE_CONTENT_TYPE_LABELS)}
                    />
                </div>

                <button
                    type="submit"
                    form="upload:form"
                    className="xl mt-6 w-full"
                    disabled={!file}
                >
                    Upload file
                </button>
            </Form>
        </div>
    );
}
